<div class="agent-informations-container" *ngIf="agent">
  <!-- Anagraphics Section -->
  <div class="section">
    <div class="section-header">
      <span>{{ "agent.single_agent.details.anagraphics" | translate }}</span>
      <button
        class="action-btn secondary-btn icon-btn"
        aria-label="Edit Anagraphics"
        (click)="edit()"
      >
        <span class="icon">
          <app-svg-icon svgIcon="pen-cc"></app-svg-icon>
        </span>
      </button>
    </div>
    <div class="info-list">
      <div class="info-row">
        <span class="label">{{
          "agent.single_agent.details.full_name" | translate
        }}</span>
        <span class="value truncate" style="max-width: 200px;" [title]="agent.first_name + ' ' + agent.last_name">{{ agent.first_name }} {{ agent.last_name }}</span>
      </div>
      <div class="info-row">
        <span class="label">{{
          "agent.single_agent.details.address" | translate
        }}</span>
        <span class="value truncate" style="max-width: 200px;" [title]="agent.address + ' - ' + agent.country">{{ agent.address + ' - ' + agent.country }}</span>
      </div>
      <div class="info-row">
        <span class="label">{{
          "agent.single_agent.details.vat" | translate
        }}</span>
        <span class="value">{{ agent.vat }}</span>
      </div>
      <div class="info-row">
        <span class="label">{{
          "agent.single_agent.details.phone" | translate
        }}</span>
        <span class="value" style="font-weight: 500;">{{ agent.phone }}</span>
      </div>
      <div class="info-row">
        <span class="label">{{
          "agent.single_agent.details.email" | translate
        }}</span>
        <span class="value email">
          <a [href]="'mailto:' + agent.email">{{ agent.email }}</a>
        </span>
      </div>
      <div class="info-row">
        <span class="label">{{
          "agent.single_agent.details.tags" | translate
        }}</span>
        <span class="value tags">
          <ng-container *ngFor="let tag of agent.tags">
            <span class="tag" [ngStyle]="{ background: tag.color }">
              {{ tag.name }}
            </span>
          </ng-container>
        </span>
      </div>
    </div>
  </div>
  <hr />
  <div class="section">
    <!-- TODO: Uncomment and reimplement when conditions tab is implemented -->
    <!-- Conditions Section -->
    <!-- <div class="section-header">
      <span>{{ "agent.single_agent.details.conditions" | translate }}</span>
      <button
        class="action-btn secondary-btn icon-btn"
        aria-label="Edit Anagraphics"
        style="cursor: not-allowed"
      >
        <span class="icon">
          <app-svg-icon svgIcon="pen-cc"></app-svg-icon>
        </span>
      </button>
    </div>
    <div class="info-list">
      <div class="info-row">
        <span class="label">
          {{ "agent.single_agent.details.billing_address" | translate }}
        </span>
        <span class="value">Viale Corsica 21, Milano - Italy</span>
      </div>
    </div>
    <hr /> -->
    <!-- Access Section -->
    <!-- TODO: Uncomment when agent portal is ready -->
    <div class="portal-access-row">
      <div>
        <span class="label">{{
          "agent.single_agent.details.portal_access" | translate
        }}</span>
        <span class="desc">{{
          "agent.single_agent.details.portal_access_desc" | translate
        }}</span>
      </div>
      <mat-slide-toggle (change)="enableOrDisableAccess($event)" [checked]="agent.is_user"></mat-slide-toggle>
    </div>
    <!-- TODO: Uncomment when last activity is implemented -->
    <!-- <div class="last-activity-row">
      <span class="label">{{
        "agent.single_agent.details.last_activity" | translate
      }}</span>
      <span class="value">06/05/2025</span>
    </div> -->
  </div>
</div>
